<template>
  <div class="filter-badges">
    <base-filter-badge v-if="models.length">
      <span slot="description"> {{ $t("shared.Model") }}: </span>
      <span v-for="({ id, text }, index) in models" :key="id">
        {{ text }}<span v-if="index + 1 < models.length">,</span>
      </span>
    </base-filter-badge>
    <base-filter-badge>
      <span slot="description">{{ $t("search.price-preferences") }}:</span>
      <span>
        {{ prices }}
      </span>
    </base-filter-badge>
    <base-filter-badge>
      <span slot="description">{{ $t("search.Year") }}:</span>
      <span>
        {{ years }}
      </span>
    </base-filter-badge>
    <base-filter-badge v-if="transmissions.length">
      <span slot="description">{{ $t("search.transmission") }}:</span>
      <span v-for="(transmission, index) in transmissions" :key="transmission">
        {{ transmission }}<span v-if="index + 1 < transmissions.length">,</span>
      </span>
    </base-filter-badge>
    <base-filter-badge v-if="fuelTypes.length">
      <span slot="description">{{ $t("search.fuel-type") }}:</span>
      <span v-for="({ id, text }, index) in fuelTypes" :key="id">
        {{ text }}<span v-if="index + 1 < fuelTypes.length">,</span>
      </span>
    </base-filter-badge>
    <base-filter-badge v-if="counties.length">
      <span slot="description">{{ $t("search.counties") }}:</span>
      <span v-for="(county, index) in counties" :key="county.id">
        {{ county.name }}<span v-if="index + 1 < counties.length">,</span>
      </span>
    </base-filter-badge>
    <router-link tag="button" to="/" class="filter-badges__button">
      {{ $t("shared.change") }}
    </router-link>
  </div>
</template>

<script>
import BaseFilterBadge from "@/components/ui/BaseFilterBadge/BaseFilterBadge";
import modelsMap from "@/constants/models";
import fuelTypesMap from "@/constants/fuelTypes";
import { mapState } from "vuex";
import { filterById } from "@/utils";
import { options } from "@/store/options.js";

const paymentTypes = {
  MONTHLY: "monthly",
  CAR_PRICE: "carPrice"
};

export default {
  name: "FilterBadges",
  components: {
    BaseFilterBadge
  },
  computed: {
    ...mapState(["search"]),
    models() {
      return filterById({
        map: modelsMap,
        arrayWithCodes: this.search.models,
        id: "id"
      });
    },
    prices() {
      const {
        paymentType,
        priceRange,
        prices: { lowest, highest }
      } = this.search;
      const isPaymentTypeMonthly = paymentType === paymentTypes.MONTHLY;
      const payment = isPaymentTypeMonthly
        ? paymentTypes.MONTHLY
        : paymentTypes.CAR_PRICE;

      const rental = isPaymentTypeMonthly ? "Monthly" : "Car price";
      const priceRangeFrom = priceRange[payment].min || lowest;
      const priceRangeTo = priceRange[payment].max || highest;

      return `${rental} / €${priceRangeFrom}-€${priceRangeTo}`;
    },
    years() {
      const {
        year: { from, to }
      } = this.search;

      const {
        year: { from: defaultFrom, to: defaultTo }
      } = options;

      return `from ${from || defaultFrom} to ${to || defaultTo}`;
    },
    transmissions() {
      return this.search.transmission.map(transmission =>
        this.$store.getters.decodeGearboxCode(transmission)
      );
    },
    fuelTypes() {
      return filterById({
        map: fuelTypesMap,
        arrayWithCodes: this.search.fuelType,
        id: "id"
      });
    },
    counties() {
      const { dealerLocations, regionsList } = this.search;

      return filterById({
        map: regionsList,
        arrayWithCodes: dealerLocations,
        id: "pk"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-badges {
  display: none;

  &__button {
    padding: 2px 10px;
    background-color: $color-blue-200;
    color: $color-white;
    margin: 0 5px 5px;
  }
}

@media screen and (min-width: $media-m) {
  .filter-badges {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
